import { render, staticRenderFns } from "./OrderInfoRootPage.vue?vue&type=template&id=0e88d784&"
import script from "./OrderInfoRootPage.vue?vue&type=script&lang=js&"
export * from "./OrderInfoRootPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports